module.exports = __webpack_public_path__ + "static/media/2016_conf_From_Idea_to_Launch.a69c6f68.png";